"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var DrawerMenu = /*#__PURE__*/function (_HTMLElement) {
  _inherits(DrawerMenu, _HTMLElement);
  var _super = _createSuper(DrawerMenu);
  function DrawerMenu() {
    'use strict';

    var _this;
    _classCallCheck(this, DrawerMenu);
    _this = _super.call(this);
    _this.el = _assertThisInitialized(_this);
    _this.mainLevel = _this.el.querySelector('.drawer-menu__contents');
    _this.init();
    return _this;
  }
  _createClass(DrawerMenu, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      // These toggle submenu panel
      this.firstLevelItemsWithChildren = this.el.querySelectorAll('.drawer-menu__item__input');
      this.firstLevelItemsWithChildren.forEach(function (input) {
        input.addEventListener('change', _this2.toggleMenuItem.bind(_this2));
      });

      // These handle closing of navigation
      this.closeButtons = this.el.querySelectorAll('[data-close]');
      this.closeButtons.forEach(function (btn) {
        btn.addEventListener('click', _this2.closeAllItems.bind(_this2));
      });
      this.overlay = this.el.querySelector('[data-overlay]');
      this.overlay.addEventListener('click', this.closeAllItems.bind(this));

      // These handle going back to previous panel
      this.secondLevelBackButtons = this.el.querySelectorAll('[data-drawer-submenu-close]');
      this.secondLevelBackButtons.forEach(function (button) {
        button.addEventListener('click', _this2.toggleSubPanel.bind(_this2));
      });
      this.secondLevelBackButtonsCloseTop = this.el.querySelectorAll('[data-drawer-main-close]');
      this.secondLevelBackButtonsCloseTop.forEach(function (button) {
        button.addEventListener('click', _this2.toggleMenuItem.bind(_this2));
      });
      // Handle opening of specific subitem from anywhere in the theme
      this.subitemOpeners = document.querySelectorAll('[data-drawer-submenu-open]');
      this.subitemOpeners.forEach(function (button) {
        button.addEventListener('mouseover', _this2.toggleMenuItemFromTheme.bind(_this2));
        button.addEventListener('mouseout', _this2.toggleMenuOutItemFromTheme.bind(_this2));
      });
    }
  }, {
    key: "closeAllItems",
    value: function closeAllItems(event, skipEl) {
      var checkboxes = this.mainLevel.querySelectorAll('input:checked');
      checkboxes.forEach(function (checkbox) {
        if (skipEl && checkbox === skipEl) {
          return;
        }
        checkbox.checked = false;
        var accordion = checkbox.closest('[data-accordion-item]');
        if (accordion) {
          accordion.classList.remove('is-open');
          if (window.innerWidth <= 820) {
            var parent = accordion.closest('.drawer-menu__contents');
            parent.classList.remove('pull-left');
          }
        }
      });
      if (!skipEl) {
        document.querySelectorAll(".header .header-shortlinks .header-shortlink").forEach(function (el) {
          el.classList.remove("active");
        });
        this.mainLevel.classList.remove('has-open-submenu');
        this.mainLevel.parentElement.classList.remove('has-open-submenu-main');
        document.body.classList.remove("drawer-menu-open");
      }
    }
  }, {
    key: "toggleMenuItem",
    value: function toggleMenuItem(scope) {
      var input = scope.currentTarget || scope;
      if (!input) return;
      if (window.innerWidth <= 1023) {} else {
        this.closeAllItems(scope, input);
      }
      var accordion = input.parentElement;
      if (!accordion) {
        return;
      }
      var accordionTopWrapper = accordion.parentElement;
      accordionTopWrapper.querySelectorAll(".drawer-menu__item").forEach(function (el) {
        if (el.querySelector(".drawer-content")) {
          if (el.classList.contains("is-open")) {} else {
            el.querySelector(".drawer-content").scrollTo(0, 0);
          }
        }
      });
      if (window.innerWidth <= 820) {
        var parent = accordion.closest('.drawer-menu__contents');
        if (parent.classList.contains("has-open-submenu")) {} else {
          parent.classList.toggle('pull-left');
        }
      }
      if (window.innerWidth <= 1023) {
        if (accordion.classList.contains('is-open')) {
          accordion.classList.remove('is-open');
          this.mainLevel.classList.remove('has-open-submenu');
          this.mainLevel.parentElement.classList.remove('has-open-submenu-main');
        } else {
          accordion.classList.add('is-open');
          this.mainLevel.classList.add('has-open-submenu');
          this.mainLevel.parentElement.classList.add('has-open-submenu-main');
        }
      } else {
        accordion.classList.toggle('is-open');
        if (accordion.classList.contains('is-open')) {
          this.mainLevel.classList.add('has-open-submenu');
          this.mainLevel.parentElement.classList.add('has-open-submenu-main');
        } else {
          this.mainLevel.classList.remove('has-open-submenu');
          this.mainLevel.parentElement.classList.remove('has-open-submenu-main');
        }
      }
    }
  }, {
    key: "toggleMenuOutItemFromTheme",
    value: function toggleMenuOutItemFromTheme(scope) {
      document.querySelector(".drawer.drawer-menu .drawer-menu__contents").addEventListener("mouseleave", function (event) {
        document.querySelector(".drawer.drawer-menu .page-overlay").click();
      }, false);
    }
  }, {
    key: "toggleMenuItemFromTheme",
    value: function toggleMenuItemFromTheme(scope) {
      var _this3 = this;
      this.closeAllItems();
      document.body.classList.add("drawer-menu-open");
      var target = false;
      var getDrawer = document.querySelector(".drawer.drawer-menu");
      var button = scope.currentTarget || scope;
      var url = button.getAttribute('data-drawer-submenu-open');
      var desktopSectionId = button.getAttribute('data-drawer-submenu-id');
      var allParentMenuWrapper = document.querySelectorAll(".parent-menu-wrapper");
      var allParentMenuRightBannerWrapper = document.querySelectorAll(".desktop-right-banner");
      var desktopSectionRightBannerId = desktopSectionId + "-top-right-banner";
      document.querySelectorAll(".header .header-shortlinks .header-shortlink").forEach(function (el) {
        el.classList.remove("active");
      });
      scope.target.classList.add("active");
      if (allParentMenuWrapper) {
        allParentMenuWrapper.forEach(function (el) {
          el.style.display = "none";
        });
      }
      if (allParentMenuRightBannerWrapper) {
        allParentMenuRightBannerWrapper.forEach(function (el) {
          el.style.display = "none";
        });
      }
      if (document.querySelector(desktopSectionId)) {
        if (document.querySelectorAll(desktopSectionId + " .drawer-single-panel-wrapper")) {
          var isMatchedCustom = false;
          var allPannels = document.querySelectorAll(desktopSectionId + " .drawer-single-panel-wrapper");
          for (var i = 0, element; element = allPannels[i]; i++) {
            if (element.querySelectorAll(".drawer-single-menu .drawer-menu__item")) {
              var singleMenu = element.querySelectorAll(".drawer-single-menu .drawer-menu__item");
              for (var j = 0, subelement; subelement = singleMenu[j]; j++) {
                if (subelement.classList.contains("--drilldown")) {
                  subelement.querySelector(".drawer-menu__item-label").click();
                  isMatchedCustom = true;
                  break;
                }
                if (isMatchedCustom) {
                  break;
                }
              }
              if (isMatchedCustom) {
                break;
              }
            }
          }
        }
        document.querySelector(desktopSectionId).style.display = "block";
      }
      if (document.querySelector(desktopSectionRightBannerId)) {
        document.querySelector(desktopSectionRightBannerId).style.display = "block";
      }
      var _iterator = _createForOfIteratorHelper(this.firstLevelItemsWithChildren),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var input = _step.value;
          if (input.getAttribute('data-href') === url) {
            target = input;
            break;
          }
        }

        // if (!target) return;
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      Woolman.ModalsAndDrawers.showModalOrDrawer(this.el.getAttribute('id'));
      var animationFinished = function animationFinished() {
        _this3.el.removeEventListener('transitionend', animationFinished);
        var evt = new Event('change');
        if (target) {
          target.checked = true;
          target.dispatchEvent(evt);
        }
      };
      this.el.addEventListener('transitionend', animationFinished);
    }
  }, {
    key: "toggleSubPanel",
    value: function toggleSubPanel(event) {
      if (window.innerWidth <= 1023) {} else {
        this.closeAllItems();
      }
      var button = event.currentTarget;
      var targetSelector = button.getAttribute('data-drawer-submenu-close');
      if (!targetSelector) {
        return;
      }
      var input = document.getElementById(targetSelector);
      if (!input) {
        return;
      }
      if (window.innerWidth <= 1023) {
        input.checked = false;
        var evt = new Event('change');
        input.dispatchEvent(evt);
      } else {
        // input.focus();
      }
    }
  }]);
  return DrawerMenu;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (customElements.get('drawer-menu') === undefined) {
  customElements.define('drawer-menu', DrawerMenu);
}

function DrawerResize(){
  if (window.innerWidth > 1023) {
    document.body.classList.remove('drawer-menu-open');
    const drawerMenuElement = document.getElementById('drawer-menu');
    drawerMenuElement.classList.remove('is-open');
  };
}
window.addEventListener('resize', function() {
  DrawerResize();
});

document.addEventListener('DOMContentLoaded', function() {
  const activeTab = localStorage.getItem('activeTab');

  if (activeTab) {
    const activeListItem = document.querySelector(`li[data-title="${activeTab}"]`);
    if (activeListItem) {
      document.querySelectorAll('.mobile-drawer-menu-flex li').forEach(function(li) {
        li.classList.remove('active');
      });
      activeListItem.classList.add('active');
      handleAccordion(activeTab);
    }
  } else {
    const defaultTab = document.querySelector('.mobile-drawer-menu-flex li');
    if (defaultTab) {
      defaultTab.classList.add('active');
      const dataTitle = defaultTab.getAttribute('data-title');
      handleAccordion(dataTitle);
    }
  }
});

function handleTabClick(event) {
  const clickedItem = event.currentTarget;

  document.querySelectorAll('.mobile-drawer-menu-flex li').forEach(function(li) {
    li.classList.remove('active');
  });

  clickedItem.classList.add('active');

  const dataTitle = clickedItem.getAttribute('data-title');
  localStorage.setItem('activeTab', dataTitle);

  handleAccordion(dataTitle);
}

function handleAccordion(dataTitle) {
  const allDivs = document.querySelectorAll('[data-accordion-item]');
  allDivs.forEach(div => {
    div.classList.remove('is-open');
    const input = div.querySelector('input[type="checkbox"]');
    if (input) {
      input.checked = false;
    }
  });

  const matchingDiv = document.getElementById(dataTitle);
  if (matchingDiv) {
    matchingDiv.classList.add('is-open');
    const divInput = matchingDiv.querySelector('input[type="checkbox"]');
    if (divInput) {
      divInput.checked = true;
    }
  }
    const logoLink = document.querySelector('.medium-up--hide .header-logo')
  if(dataTitle == "drawer-menu__Men"){
  logoLink.href = "/pages/men"
  }else if(dataTitle == "drawer-menu__Kids"){
logoLink.href = "/pages/kids"
  }else if(dataTitle == "drawer-menu__Home"){
logoLink.href = "/pages/home"
  }else{
logoLink[0].href = "/"
  }
}

document.querySelectorAll('.mobile-drawer-menu-flex li').forEach(item => {
  item.addEventListener('click', handleTabClick);
});

document.querySelectorAll('.close').forEach(button => {
  button.addEventListener('click', function() {
    const activeTab = localStorage.getItem('activeTab');
    handleAccordion(activeTab);
  });
});